import React from 'react'
import Cta from '../components/cta/index.js'

export default ({ cta }) =>
  cta.map(item => <Cta key={item.originalId} {...item} />)
